const Jaqi = () => {
  return <div data-testid="jaqi" />
}

export default Jaqi
